export var ManualDepositType;
(function (ManualDepositType) {
    ManualDepositType["DEPOSIT"] = "manual_deposit";
    ManualDepositType["EVENT"] = "manual_event";
    ManualDepositType["OTHER"] = "manual_other";
    ManualDepositType["RISK_ADJUSTMENT"] = "manual_risk_adjustment";
})(ManualDepositType || (ManualDepositType = {}));
//# sourceMappingURL=ManualDepositType.js.map